import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import PndApi from '../../../../utils/pnd/PndRestApi';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import DriverEmployer from './DriverEmployer';
import { showNotification } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import { Box } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import PageHeader from 'src/shared/components/layout/PageHeader';

const DriverEmployerDetailsIndex = () => {
  useEffect(() => {
    getAllDriverEmployerDetails();
  }, [])
  const [reactTableData, setReactTableData] = useState({ tableRowsData: [] });
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [loading, setLoading] = useState(false);

  const getAllDriverEmployerDetails = async () => {
    try {
      setLoading(true);
      const response = await PndApi.GetAllDriverEmployer();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableRowsData: response.data.data });
      } else if (response?.data?.status && response?.data?.status === 204) { //No Record Found
        setNoRecordFound(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <Container fluid style={{ maxWidth: '1400px' }}>
        <PageHeader
          icon={<GroupIcon fontSize="large" />}
          title="Leased Rider Agencies"
          subtitle="View and track credentials and status of leased rider agencies."
          gradient="linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)"
        />

        {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}

        <Box sx={{ position: 'relative' }}>
          {(reactTableData && reactTableData.tableRowsData && reactTableData.tableRowsData.length > 0) && !isNoRecordFound && (
            <DriverEmployer reactTableData={reactTableData} isNoRecordFound={isNoRecordFound} />
          )}
          {isNoRecordFound && (
            <>
              <DriverEmployer isNoRecordFound={isNoRecordFound} />
              <SnackbarContent message={'No Record Found'} sx={{ mt: 2 }} />
            </>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default DriverEmployerDetailsIndex;